import { CheckoutField } from '../../types';
import { CheckoutSection } from './CheckoutSection';

interface OrderInformationSectionProps {
  fields: CheckoutField[];
  values: Record<string, string>;
  onChange: (values: Record<string, string>) => void;
}

export function OrderInformationSection({ fields, values, onChange }: OrderInformationSectionProps) {
  if (fields.length === 0) return null;

  const handleChange = (name: string, value: string) => {
    onChange({ ...values, [name]: value });
  };

  const tomorrow = new Date(Date.now() + 86400000).toISOString().split('T')[0];

  return (
    <CheckoutSection title="Order Information">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {fields.map((field) => {
          const value = values[field.name] ?? '';
          const inputClass =
            'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500';

          return (
            <div key={field.name} className="flex flex-col">
              <label htmlFor={`cf_${field.name}`} className="block text-sm font-medium text-gray-700 mb-1">
                {field.label}
                {field.required ? (
                  <span className="text-red-500 ml-1" aria-hidden="true">*</span>
                ) : (
                  <span className="text-gray-400 text-xs ml-1">(optional)</span>
                )}
              </label>

              {field.type === 'select' ? (
                <select
                  id={`cf_${field.name}`}
                  value={value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  required={field.required}
                  className={inputClass}
                >
                  <option value="">Select {field.label}</option>
                  {(field.options ?? []).map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              ) : field.type === 'email' ? (
                <input
                  type="email"
                  id={`cf_${field.name}`}
                  value={value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  required={field.required}
                  className={inputClass}
                />
              ) : field.type === 'date' ? (
                <input
                  type="date"
                  id={`cf_${field.name}`}
                  value={value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  required={field.required}
                  min={field.dateType === 'future' ? tomorrow : undefined}
                  className={inputClass}
                />
              ) : (
                <input
                  type="text"
                  id={`cf_${field.name}`}
                  value={value}
                  onChange={(e) => handleChange(field.name, e.target.value)}
                  required={field.required}
                  maxLength={field.charLimit ?? undefined}
                  className={inputClass}
                />
              )}
            </div>
          );
        })}
      </div>
    </CheckoutSection>
  );
}
